import { styled } from 'styled-components';
import { getFontSize } from '../../abstracts/typography';
import { Link } from '../Link';
import { colors } from '../../abstracts';
import { dontForwardProps } from '../../util';
export const CreditCardFieldMaskingToggle = styled.button.withConfig({
  componentId: "aui__sc-qyf2hh-0"
})(["border:none;background:none;position:relative;font-size:", ";padding-right:0;padding-left:0;line-height:150%;color:currentColor;cursor:pointer;"], getFontSize(1));
export const NeedHelpLink = styled(Link).withConfig({
  componentId: "aui__sc-qyf2hh-1"
})(["font-size:", ";font-weight:400;padding:0.25rem 0.75rem;align-items:flex-end;text-align:right;color:#6e767d;left:calc(50% - 4.438rem / 2 + 7.031rem);"], getFontSize(1));
export const Container = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-qyf2hh-2"
})(["display:flex;flex-direction:column;min-width:20rem;align-items:flex-end;.CreditCardFieldContainer{min-width:20rem;}.CreditCardRightIcon{color:", ";opacity:", ";}"], colors.black, ({
  $disabled
}) => $disabled ? 0.3 : 1.0);